import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import GridLayout from "../../components/GridLayout"
import PageLayout from "../../components/PageLayout"
import GridTextProjectElement from "../../components/GridTextProjectElement"
import { projectNames } from "../../context/consts"
import Seo from "../../components/Seo"


const FutureairSamPage = () => {

    const imageComponents = [
        <StaticImage key={1} src="./../../images/futureair-sam/futureair-sam-0.jpg" alt="" layout="fullWidth"></StaticImage>,
        <GridTextProjectElement key={2} projectName={projectNames.FUTUREAIR_SAM} />,
        <StaticImage key={3} src="./../../images/futureair-sam/futureair-sam-1.jpg" alt="" layout="fullWidth"></StaticImage>,
        <StaticImage key={4} src="./../../images/futureair-sam/futureair-sam-2.jpg" alt="" layout="fullWidth"></StaticImage>,
        <StaticImage key={5} src="./../../images/futureair-sam/futureair-sam-3.jpg" alt="" layout="fullWidth"></StaticImage>,
        <StaticImage key={6} src="./../../images/futureair-sam/futureair-sam-4.jpg" alt="" layout="fullWidth"></StaticImage>,
    ]

    return (
        <PageLayout firstHead="futureair" secondHead="sam2.0sensor">
            <GridLayout components={imageComponents}></GridLayout>
            <Seo subTitle="futureair sam2.0sensor" /> 
        </PageLayout>
    )

}

export default FutureairSamPage